import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { CarregamentoService } from './core/service/carregamento/carregamento.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [SharedModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  carregando = false;

  constructor(private readonly router: Router, public carregamentoService: CarregamentoService) {}

  ngOnInit(): void {
    this.carregamentoService.carregando$.subscribe((valor) => {
      Promise.resolve().then(() => {
        this.carregando = valor;
      });
    });

    if (environment.periodoEleitoral) {
      document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]').forEach((el) => el.remove());
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.type = 'image/x-icon';
      favicon.href = 'favicon-eleitoral.ico';
      document.head.appendChild(favicon);
    }
  }
}
